export default __webpack_public_path__ + "images/29b04a103c8b959cb40c731960379f8b-acoustic.webp";